// This file is auto-generated by @hey-api/openapi-ts
/**
 * Game league associated with this position
 */
export const GameLeagues = {
    DEV: 'DEV',
    TL: 'TL',
    QA: 'QA'
};
/**
 * Legal contract type of the collaborator (HPP, DPP, ZL). Null when not set.
 */
export const UserLegalType = {
    HPP: 'HPP',
    DPP: 'DPP',
    ZL: 'ZL'
};
/**
 * Rating value of the feedback
 */
export const CollaboratorFeedbackValue = {
    BAD: 'BAD',
    GOOD: 'GOOD',
    GREAT: 'GREAT',
    NONE: 'NONE'
};
/**
 * Rating given by the collaborator
 */
export const Collaborator1On1Rating = {
    BAD: 'BAD',
    OK: 'OK',
    GREAT: 'GREAT'
};
/**
 * Rating of how well goals were met
 */
export const SitdownRatingEnum = {
    FAIL: 'FAIL',
    OK: 'OK',
    GOOD: 'GOOD'
};
/**
 * Direction of ordering (ASC or DESC)
 */
export const SortDir = { ASC: 'ASC', DESC: 'DESC' };
/**
 * Current state of the document
 */
export const DocumentState = {
    SIGNED: 'SIGNED',
    REJECTED: 'REJECTED',
    WAITING_FOR_SIGN: 'WAITING_FOR_SIGN',
    CANCELED: 'CANCELED'
};
/**
 * List of available office absence types
 */
export const OfficeAbsenceType = {
    HOME_OFFICE: 'HOME_OFFICE',
    HOLIDAY: 'HOLIDAY',
    WORK_TRAVEL: 'WORK_TRAVEL',
    ILLNESS: 'ILLNESS',
    INACCESSIBILITY: 'INACCESSIBILITY'
};
/**
 * List of available office absence states
 */
export const OfficeAbsenceState = {
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    AWAITING_CANCELLATION_APPROVAL: 'AWAITING_CANCELLATION_APPROVAL',
    DONE: 'DONE',
    CANCELED: 'CANCELED',
    WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL'
};
/**
 * List of available bonus XP donor types
 */
export const BonusXpDonorType = { SYSTEM: 'SYSTEM', USER: 'USER' };
/**
 * Current state of the record item
 */
export const WorkingTimeRecordState = {
    WAITING_FOR_CONFIRMATION: 'WAITING_FOR_CONFIRMATION',
    WAITING_FOR_CLOSURE: 'WAITING_FOR_CLOSURE',
    CLOSED: 'CLOSED',
    RETURNED: 'RETURNED'
};
/**
 * Type of the working time record
 */
export const WorkingTimeRecordType = {
    VACATION_480: 'VACATION_480',
    VACATION_240: 'VACATION_240',
    NATIONAL_HOLIDAY: 'NATIONAL_HOLIDAY',
    ILLNESS: 'ILLNESS',
    UNPAID_TIME_OFF: 'UNPAID_TIME_OFF',
    INACCESSIBILITY: 'INACCESSIBILITY',
    WORK: 'WORK'
};
